import { IWorkflowProduct } from '../../../../../../interfaces/runOrchestration/workflowRow';

type ParameterType = 'text' | 'select' | 'password';

interface Parameter {
  maxLength?: number;
  name: string;
  options?: string[];
  paramId: keyof IWorkflowProduct;
  required?: boolean;
  type: ParameterType;
}

export const parameters: Parameter[] = [
  { name: 'Product Name', paramId: 'name', required: true, type: 'text' },
  {
    name: 'Business Product',
    paramId: 'businessProduct',
    required: false,
    type: 'text',
  },
  {
    name: 'Throttle Rate',
    paramId: 'throttleRate',
    required: false,
    type: 'text',
  },
  {
    name: 'Cron Trigger',
    paramId: 'cronTrigger',
    required: false,
    type: 'text',
  },
  {
    name: 'Cron Timezone',
    paramId: 'cronTimezone',
    required: false,
    type: 'text',
  },
  {
    name: 'SFTP Dropzone',
    paramId: 'sftpDropzone',
    required: false,
    type: 'text',
  },
  {
    name: 'SFTP Private Key',
    paramId: 'sftpPrivateKey',
    required: false,
    type: 'text',
  },
  {
    name: 'FTP Dropzone',
    paramId: 'ftpDropzone',
    required: false,
    type: 'text',
  },
  {
    name: 'S3 Dropzone',
    paramId: 's3Dropzone',
    required: false,
    type: 'text',
  },
  {
    name: 'S3 Access Key',
    paramId: 's3AccessKey',
    required: false,
    type: 'password',
    maxLength: 50,
  },
  {
    name: 'S3 Private Key',
    paramId: 's3PrivateKey',
    required: false,
    type: 'password',
    maxLength: 50,
  },
  {
    name: 'Notification Emails',
    paramId: 'notifyEmails',
    required: false,
    type: 'text',
  },
  {
    name: 'Event Params Mapping',
    paramId: 'eventParametersMapping',
    required: false,
    type: 'text',
  },
  {
    name: 'Reporting Index',
    paramId: 'reportingIndex',
    required: false,
    type: 'text',
  },
  {
    name: 'UnpackProduct',
    options: ['false', 'true'],
    paramId: 'unpackInput',
    required: false,
    type: 'select',
  },
];
